import { useState } from 'react'
import { HaloUserCombobox } from '@/features/halocrm-user/HaloUserCombobox'
import { useAssignUserRegion } from '@/features/region/hooks'

interface AddUserToRegionProps {
  regionCode: string
}

/** Search-based picker (2000+ userów) dodający handlowca do regionu. Przypisanie do innego
 *  regionu przenosi go (upsert), oba widoki odświeżają się przez invalidację. */
export function AddUserToRegion({ regionCode }: AddUserToRegionProps) {
  const [value, setValue] = useState<number | null>(null)
  const assign = useAssignUserRegion()

  const handleChange = (userId: number | null) => {
    if (userId == null) return
    assign.mutate({ userId, regionCode }, { onSuccess: () => setValue(null) })
  }

  return (
    <div className="w-64">
      <HaloUserCombobox value={value} onChange={handleChange} placeholder="Dodaj handlowca…" />
    </div>
  )
}
